import { FunctionComponent } from "react";

import { PaginationContextProvider } from "@ds-cps/ui";

import { ResourcesContextProvider } from "@resource/components/context/ResourcesContextProvider";
import { SectionWithFiltersAndSearch } from "@resource/components/SectionWithFiltersAndSearch";
import { SectionWithResourcesTable } from "@resource/components/SectionWithResourcesTable";

export const ResourcesTab: FunctionComponent = () => {
  return (
    <ResourcesContextProvider>
      <PaginationContextProvider>
        <div data-testid="organization-resources-container">
          <SectionWithFiltersAndSearch />
          <SectionWithResourcesTable />
        </div>
      </PaginationContextProvider>
    </ResourcesContextProvider>
  );
};
